<template>
    <v-row class="light--text" v-show="selectedMenu === 4">
        <v-container fluid>
            <v-data-table
                    :headers="headers"
                    :items="commands"
                    class="elevation-1"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Переменные</v-toolbar-title>
                        <v-divider
                                class="mx-4"
                                inset
                                vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                        <v-btn color="blue lighten-2" dark @click="newItem">Добавить команду</v-btn>
                        <v-dialog v-model="dialog" max-width="500px">

                            <v-card>
                                <v-card-title>
                                    <span class="headline">Редактирование команды</span>
                                </v-card-title>

                                <v-card-text>
                                        <v-row>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-text-field v-model="commandFormNew.cmd"
                                                              label="Команда"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-select
                                                        :items="controllerItems"
                                                        label="Список разделов"
                                                        v-model="commandFormNew.ctrl"
                                                        hide-details/>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-select
                                                        :items="actions"
                                                        label="Действие"
                                                        v-model="commandFormNew.act"
                                                        item-value="value"
                                                        item-text="text"
                                                        hide-details/>
                                            </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                                <v-select
                                                        :items="messages"
                                                        label="Сообщение"
                                                        v-model="commandFormNew.msg"
                                                        item-value="id"
                                                        item-text="text"
                                                        hide-details
                                                        v-show="messageMode"
                                                />
                                            </v-col>
                                        </v-row>
                                </v-card-text>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="dialog = false">Отмена</v-btn>
                                    <v-btn color="blue darken-1" text @click="saveItem">Сохранить</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.ctrl="{ item }">
                    {{getCtrlDescription(item.ctrl)}}
                </template>
                <template v-slot:item.act="{ item }">
                    {{getActionDescription(item)}}
                </template>
                <template v-slot:item.msg="{ item }">
                    {{getMessageTitle(item)}}
                </template>
                <template v-slot:item.action="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                    >
                        edit
                    </v-icon>
                    <v-icon
                            small
                            class="mr-2"
                            @click="deleteItem(item)"
                    >
                        delete
                    </v-icon>
                </template>
            </v-data-table>
        </v-container>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <dialog-confirmation ref="confirm" :dialogParams="dialogParams"></dialog-confirmation>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogConfirmation from '../../dialogs/DialogConfirmation'
import messageConstants from '../message/messageConstants'
export default {
    name: 'BotModerator',
    data() {
        return {
            moderator_id: null,
            dialogParams: {},
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            commands: [],
            commandFormNew: {
                cmd: '',
                ctrl: '',
                type: '',
                act: '',
                msg: null
            },
            commandFormDefault: {
                cmd: '',
                ctrl: '',
                type: '',
                act: '',
                msg: null
            },
            headers: [
                { text: 'Команда', align: 'left', sortable: false, value: 'cmd' },
                { text: 'Раздел', value: 'ctrl', sortable: false },
                { text: 'Действие', value: 'act', sortable: false },
                { text: 'Сообщение', value: 'msg', sortable: false },
                { text: 'Редактировать', value: 'action', sortable: false }
            ],
            dialog: false,
            editedIndex: -1
        }
    },
    components: {
        DialogConfirmation
    },
    props: ['botModel', 'selectedMenu'],
    methods: {
        loadCommands() {
            this.commands = this.botModel.commands === null ? [] : JSON.parse(this.botModel.commands)
        },
        newItem() {
            this.editedIndex = -1
            this.commandFormNew = Object.assign({}, this.commandFormDefault)
            this.dialog = true
        },
        editItem(item) {
            this.editedIndex = this.commands.indexOf(item)
            this.commandFormNew = Object.assign({}, item)
            this.dialog = true
        },
        saveItem() {
            if (!this.messageMode) {
                this.commandFormNew.msg = null
            }
            if (this.editedIndex > -1) {
                Object.assign(this.commands[this.editedIndex], this.commandFormNew)
            } else {
                this.commands.push(this.commandFormNew)
            }
            this.$emit('updateCommands', this.commands)
            this.close()
        },
        async deleteItem(item) {
            let index = this.commands.indexOf(item)
            this.$refs.confirm.open('Удаление Команды', 'Вы действительно хотите удалить?',
                { color: 'red', agree: 'Подтверждаю', cancel: 'Отмена' })
                .then((confirm) => {
                    if (confirm === true) {
                        this.commands.splice(index, 1)
                    }
                })
        },
        getCtrlDescription(key) {
            let controller = messageConstants.controllerItems.find(controller => controller.value === key)
            return !controller ? 'Раздел' : controller.text
        },
        getActionDescription(item) {
            if (messageConstants.actions.hasOwnProperty(item.ctrl) && item.act) {
                let action = messageConstants.actions[item.ctrl].find(action1 => action1.value === item.act)
                if (action) { return action.text } else { return '' }
            } else {
                return ''
            }
        },
        getMessageTitle(item) {
            if (item.msg) {
                let message = this.messages.find(message => message.id === item.msg)
                if (message) { return message.title } else { return '' }
            } else {
                return ''
            }
        },
        actionItems(controller) {
            return messageConstants.actions[controller]
        },
        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.commandFormNew = Object.assign({}, this.commandFormDefault)
                this.editedIndex = -1
            })
        }
    },
    computed: {
        ...mapGetters({
            messages: 'messages/messages',
            moderators: 'bots/moderators',
            modelModeratorDef: 'bots/modelModeratorDef',
            getModeratorById: 'bots/getModeratorById'
        }),
        controllerItems() {
            return messageConstants.controllerItems.filter(controller => controller.value !== 'variable')
        },
        buttonTypes() {
            return messageConstants.buttonTypes
        },
        actions() {
            return this.commandFormNew.ctrl === '' ? [] : messageConstants.actions[this.commandFormNew.ctrl]
        },
        messageMode() {
            return this.commandFormNew.ctrl === 'message' && this.commandFormNew.act !== 'resetReplyMessage'
        }
    },
    watch: {
        selectedMenu(value) {
            if (value === 4) { this.loadCommands() }
        }
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container {
        height: 60vh;
        display: flex;
        flex-direction: column;
    }
    .container-with-cards {
        height: calc(100vh - 150px);
    }
</style>
